import * as Sentry from '@sentry/nuxt'
import { useRuntimeConfig } from '#imports'

import { SENTRY_IGNORED_WSS_EMIT_ERRORS } from '@/api/ws/constants'

const config = useRuntimeConfig()
const sentryEnvironment = config.public.sentryEnvironment || 'unknown'
const isDev = import.meta.dev

if (!isDev) {
  Sentry.init({
    dsn: 'https://5609aafd03c176932d4f9fbed1effc46@sentry-ext-k8s.sportsapi.ru/14',
    environment: sentryEnvironment,
    release: 'ligapass@1.0.0',
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration()
    ],
    ignoreErrors: SENTRY_IGNORED_WSS_EMIT_ERRORS,
    tracesSampleRate: 1.0,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0
  })
}
